export enum ComplexSearchEvents {
  COMPLEX_SEARCH_CHANGED = 'complexSearchChanged',
}

export enum filterWidth {
  SMALL = '80',
  MEDIUM = '160',
  LARGE = '240',
  XLARGE = '320',
  XXLARGE = '400',
  FULL = 'full',
}

export enum dropdownWidth {
  SMALL = '80',
  MEDIUM = '160',
  LARGE = '240',
  XLARGE = '320',
  XXLARGE = '400',
  FULL = 'full',
}

export enum inputWidth {
  SMALL = '80',
  MEDIUM = '160',
  LARGE = '240',
  XLARGE = '320',
  XXLARGE = '400',
  FULL = 'full',
}
